import React, { useEffect, useRef } from 'react';
import { ImageSlideTextBlockContainer, ProgressBar, ProgressBarFilled } from './ImageSlideTextBlock.styles';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';

interface ImageSlideTextBlockProps {
  title: string;
  description: string;
  active?: boolean;
  onSlideClick: () => void;
  slideDuration: number;
}

const ImageSlideTextBlock = ({
  title,
  description,
  onSlideClick,
  active,
  slideDuration,
}: ImageSlideTextBlockProps): JSX.Element => {
  const progressBarFilledRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!progressBarFilledRef.current) return;

    if (active) {
      progressBarFilledRef.current.style.transitionDuration = `${slideDuration}ms`;
      progressBarFilledRef.current.style.width = '100%';
    } else {
      progressBarFilledRef.current.style.transitionDuration = '1000ms';
      progressBarFilledRef.current.style.width = '0%';
    }
  }, [active, slideDuration, progressBarFilledRef]);

  return (
    <ImageSlideTextBlockContainer onClick={onSlideClick}>
      <ProgressBar>
        <ProgressBarFilled ref={progressBarFilledRef} />
      </ProgressBar>

      <Heading
        text={title}
        standardSize='1.25'
        align='left'
        className='title-heading'
      />
      <Paragraph
        text={description}
        align='left'
        standardSize='1'
      />
    </ImageSlideTextBlockContainer>
  );
};

export default ImageSlideTextBlock;
